const zh = {
    navtophome: "主页",
    navtopTechnical: "技术引擎",
    navtopTurnkey: "解决方案",
    navtopOpen: "产品中心",
    navtopAbout: "关于我们",
    navtopKnowledge: "文档中心",
    navtoptech: '产品博客',
    navtopabout: "关于诺科",
    navtopproduct: "产品中心",
    navtopsolution: "解决方案",
    navtopjoinUS: "加入我们",
    navtopcontact: "联系我们",
    Neucore: "Neucore",
    "To be the leading vendor of edge AI in China": "快速落地的人工智能方案商",
    "See Our Solution": "产品中心",
    homeproduct: "我们的产品",

    Function: "功能体验",
    Feature: "产品优势",
    Scenario: "推荐场景",
    Application: "合作案例 ",


    UseSecne: "应用场景",

    AFeatureT0: "大量数据",
    AFeatureT1: "场景优化",
    AFeatureT2: "识别率高",
    AFeatureT3: "人脸属性",
    AFeatureT4: "活体验证",
    AFeatureT5: "多角度",
    AFeatureTP0: "海量数据集，来源于实际摄像头，自动标注及人工标注",
    AFeatureTP1: "在1:20000场景下达到98%以上的准确率，误识别率低于0.05%",
    AFeatureTP2: "针对真实场景，算法在线优化并持续提升",
    AFeatureTP3: "多人脸属性，戴帽子，眼镜，口罩，表情性别，年龄等识别",
    AFeatureTP4: "双目活体验证，根据双目计算距离和视差，拒绝视频、照片通过",
    AFeatureTP5: "侧脸、低头等多角度下的人脸选优和识别",
    AScenarioT0: "人脸门禁",
    AScenarioT1: "人证比对",
    AScenarioT2: "人脸属性",
    AScenarioTP0: "人脸识别门禁，提供入口通行解决方案",
    AScenarioTP1: "身份照片和真人人脸做比对，确定持证人一致",
    AScenarioTP2: "识别出人脸附加的属性，扩展应用场景",

    BFeatureT0: "大量数据",
    BFeatureT1: "运行速度快",
    BFeatureT2: "场景优化",
    BFeatureT3: "去重逻辑",
    BFeatureT4: "识别率高",
    BFeatureT5: "支持自定义",
    BFeatureTP0: "海量数据集，来源于实际摄像头，自动标注及人工标注",
    BFeatureTP1: "网络为端侧智能设备优化，实时输出结果",
    BFeatureTP2: "针对真实场景，算法在线优化并持续提升",
    BFeatureTP3: "通过Re-ID和人脸识别技术实现复杂的去重逻辑",
    BFeatureTP4: "精准的识别出人体骨骼关节点和手势",
    BFeatureTP5: "用户可以自定义行为，动作和手势",
    BScenarioT0: "客流统计",
    BScenarioT1: "行为分析",
    BScenarioT2: "姿态关节",
    BScenarioTP0: "基于行人跟踪的客流统计，结合人脸去重，可以实现90%准确度的人头计数",
    BScenarioTP1: "分析行为、动作和手势来实现疲劳驾驶检测、摔倒检测等",
    BScenarioTP2: "识别出人体的关键骨骼点，辨识姿态是否正确",

    CFeatureT0: "大量数据",
    CFeatureT1: "车辆轨迹",
    CFeatureT2: "场景优化",
    CFeatureT3: "识别率高",
    CFeatureT4: "运行速度快",
    CFeatureT5: "车辆属性",
    CFeatureTP0: "海量数据集，来源于实际摄像头，自动标注及人工标注",
    CFeatureTP1: "通过车辆Re-ID和车牌识别技术实现复杂的车辆轨迹跟踪逻辑",
    CFeatureTP2: "针对真实场景，算法在线优化并持续提升",
    CFeatureTP3: "精准的识别车牌号码和车身属性",
    CFeatureTP4: "网络为端侧智能设备优化，实时输出结果",
    CFeatureTP5: "多种车身属性同步输出，车身颜色、型号等",
    CScenarioT0: "智能卡口",
    CScenarioT1: "违章停车",
    CScenarioT2: "车流统计",
    CScenarioTP0: "基于车牌、车型、车辆属性等信息对车辆身份进行识别校验，实现无卡、无人的智能化卡口管理",
    CScenarioTP1: "判断路边是否有违章停车，并进一步识别违章车辆的车牌号码、品牌型号，实现自动化的违章审计",
    CScenarioTP2: "实时监控道路、路口的车流量，自动统计不同时段各类车辆的进出车流量",


    OFeatureT0: "大量数据",
    OFeatureT1: "运行速度快",
    OFeatureT2: "场景优化",
    OFeatureT3: "识别率高",
    OFeatureT4: "位置信息",
    OFeatureT5: "支持自定义",
    OFeatureTP0: "海量数据集，来源于实际摄像头，自动标注及人工标注",
    OFeatureTP1: "网络为端侧智能设备优化，实时输出结果",
    OFeatureTP2: "针对真实场景，算法在线优化并持续提升",
    OFeatureTP3: "精准的识别所训练的物体及相关属性",
    OFeatureTP4: "物体在画面中的位置可返回，用于判断物体是否移动",
    OFeatureTP5: "用户可以自定义物体类别，感兴趣的物体",
    OScenarioT0: "Logo识别",
    OScenarioT1: "物体识别",
    OScenarioT2: "遗留物识别",
    OScenarioTP0: "识别视频流中的Logo所在区域以及Logo类别",
    OScenarioTP1: "识别出特定的物体，比如说安全帽，徽章，着装等",
    OScenarioTP2: "实时监控画面中是否有陌生遗留物体",

    homenavFT: "人脸识别",
    homenavFT0: "人脸检测",
    homenavFT1: "多人脸检测",
    homenavFT2: "人脸属性",
    homenavFT3: "五官定位",
    homenavFT4: "人脸对比",
    homenavFT5: "人证核验",
    homenavFT6: "活体检测",
    homenavFT7: "人脸特征值",
    homenavFT8: "人脸关键点",

    homenavBT: "人体分析",
    homenavBT0: "行人检测",
    homenavBT1: "Re-ID及跟踪",
    homenavBT2: "骨骼关节点",
    homenavBT3: "手势识别",

    homenavCT: "车辆结构化",
    homenavCT0: "车辆检测",
    homenavCT1: "车型识别",
    homenavCT2: "车辆属性识别",
    homenavCT3: "车牌检测",

    homenavOT: "物体检测",
    homenavOT0: "Logo检测",
    homenavOT1: "遗留物检测",
    homenavOT2: "安全帽检测",

    homenav1RT: "新零售",

    RetailScenario: "业务场景",

    RetailFlow: "方案图例",

    SolutionFlow: "方案构成",

    SolutionP0: "麦克风列阵算法",

    RetailFlowH0: "方案构成",
    RetailFlowH1: "数据流程",

    RetailArchitecture: "方案图例",

    RetailFeature: "方案优势",

    RetailFeatureH0: "低系统成本",
    RetailFeatureP0: "本地或云端无需AI服务器，端侧设备内置人工智能算法",

    RetailFeatureH1: "快速部署",
    RetailFeatureP1: "整体系统非常精简，方便快速部署及后期运维",

    RetailFeatureH2: "创新商务模式",
    RetailFeatureP2: "算法和功能套餐化，可远程动态激活和管理",

    homenav1RT0: "客户画像",

    homenav1RT0P0: "通过人脸检测抓拍、和库中人脸比对的方式获取来人身份信息，可用于识别门店会员，推送给店员，进而实现个性化服务和会员关怀，提升顾客满意度，促进消费转化。",
    homenav1RT0P1: "通过与会员系统中的购买记录、联系方式等信息匹配，实现更精准的营销。",
    homenav1RT0P2: "智能摄像头或边缘服务器，智能云端",
    homenav1RT0P3: "技术引擎：人脸识别",

    homenav1RT1: "远程巡店",
    homenav1RT1P0: "基于人形检测与跟踪，人脸检测、去重和选优逻辑。在本日内，将同一个人的最早时间记录与最后时间记录相减，即为本次驻店时长。",
    homenav1RT1P1: "顾客的驻店时长及统计信息可以反映出店员接待和推销是否吸引顾客，以及判断该顾客是不是潜在的买家。",
    homenav1RT1P2: "实现方式：智能摄像头或边缘服务器，智能云端",
    homenav1RT1P3: "技术引擎：人体分析，人脸识别",

    homenav1RT2: "客流统计",
    homenav1RT2P0: "基于人形检测与跟踪，人脸检测、去重和选优逻辑，实时分析进店客人流量、回头客流量。",
    homenav1RT2P1: "客流量对于运营情况分析是十分重要的数据，通过精准的流量统计信息（按天、按周、按月查看），让运营者对店铺客流情况了如指掌，了解运营状态进而做出更准确的经营决策。",
    homenav1RT2P2: "实现方式：智能摄像头或边缘服务器，智能云端",
    homenav1RT2P3: "技术引擎：人体分析，人脸识别",

    homenav1RT3: "热点区域分析",
    homenav1RT3P0: "基于人形检测与跟踪，人头统计，结合摄像头的位置和店内商品布局图，确定热点区域。",
    homenav1RT3P1: "热点区域及商品关注度可以让运营者了解到商品的推广是否符合预期，是否需要通过适当的活动来增加客流，以及引流顾客到指定的商品所在位置。",
    homenav1RT3P2: "实现方式：智能摄像头或边缘服务器，智能云端",
    homenav1RT3P3: "技术引擎：人体分析",

    homenav1RT4: "员工在岗",
    homenav1RT4P0: "通过人形检测、人脸检测抓拍、和员工库中人脸比对的方式确定员工是否到岗，此种方法优于传统的打卡制度，可实现无感签到，让员工更专注于工作。",
    homenav1RT4P1: "实现方式：智能摄像头或边缘服务器，智能云端",
    homenav1RT4P2: "技术引擎：人体分析，人脸识别",
    homenav1RT4P3: "",

    homenav1RT5: "远程巡店",
    homenav1RT5P0: "运营者可以在任何时刻通过手机APP或电脑端浏览器实时查看店铺内的情况、巡查特殊区域、通过语音对讲来阻止错误行为。",
    homenav1RT5P1: "实现方式：智能摄像头，智能云端",

    homenav1ET: "智慧安防",

    homenav1ET0: "班牌机",

    homenav1ET1: "人体分析",
    homenav1ET1P0: "校门口部署人脸识别摄像头同时捕捉进出校园人脸，实现学生、老师及家长的识别，有效提高通行效率，确保校园安全。",
    homenav1ET1P1: "对于宿舍、实验室、图书馆等安全级别较高的场所，通过人证比对，解决冒用证件现象，有效防止没有通过审核的人员入内，保障校园安全性",
    homenav1ET1P2: "实现方式：智能摄像头，人脸门禁",
    homenav1ET1P3: "技术引擎：人脸识别，人证比对",

    homenav1ET2: "车辆分析",
    homenav1ET2P0: "通过在教室部署摄像头，可同时捕捉教室里的学生脸部，实现多人同时考勤，数秒内完成人脸捕捉、身份识别的全过程，有效提高考勤效率，同时针对走班制学生考勤，更加便于管理。",
    homenav1ET2P1: "实现方式：智能摄像头",
    homenav1ET2P2: "技术引擎：人脸识别",

    homenav1ET3: "物体分析",
    homenav1ET3P0: "通过在教室部署摄像头，对学生课堂状态进行自动监测，包括学生人数、姿态、行为、面部角度、表情等，实现抬头率、专注度、离席率等课堂效果指标的智能统计。该方案同样适用于远程教学场景。",
    homenav1ET3P1: "实现方式：智能摄像头",
    homenav1ET3P2: "技术引擎：人脸识别，人脸属性，姿态分析，人体分析",

    homenav1ET4: "区域周界",
    homenav1ET4P0: "整合实时人脸采集、人脸倒查、人脸库搜索，构建实时性的采集、预警、查询等监控业务功能体系，有效解决安防监控系统的自动化和时效性问题。",
    homenav1ET4P1: "实现方式：智能摄像头",
    homenav1ET4P2: "技术引擎：人脸识别，人体分析，安防监控",

    homenav1BT: "智慧车载",

    homenav1BT0: "司乘行为分析",

    homenav1BT1: "高级辅助驾驶",

    homenav1BT2: "访客管理",

    homenav1BT3: "电梯精准广告",

    homenav1FT: "智慧工厂",

    homenav1FT0: "标识识别",

    homenav1FT1: "物体识别",

    homenav1FT2: "场地管理",

    homenav1CT: "公交车载",

    homenav1CT0: "客流统计",

    homenav1CT1: "在逃犯人脸识别",

    homenav1CT2: "疲劳检测",

    homenav1SCT: "智慧工地",

    homenav1SCT0: "安全帽识别",

    homenav1SCT1: "人脸识别通行",

    homenav1SCT2: "场内实时人数",

    homenav1SHT: "智慧医院",

    homenav1SHT0: "人证核验取号",

    homenav1SHT1: "黑名单识别",


    homenav1SPT: "智慧停车",

    homenav1SPT0: "车牌识别计费",

    homenav1SPT1: "无牌车辆计费",

    detail_label0: '产品概述',
    detail_label1: '技术参数',
    detail_label2: '文档下载',

    moduleDesctiption: 'Neucore NeuCamera系列智能摄像头，采用低功耗高性能人工智能芯片，以及Neucore先进的人工智能算法，实现5M/5M像素视频流实时编码的同时，进行人/车/物等对象的识别。多种去重方式，为您的网络和服务器最大可能地减负。5万大容量目标库，灵活的功能配置。超过99%的识别率，毫秒级的响应速度。操作简单，安装方便。简洁的自然散热设计，能在各种高低温环境中轻松运行。支持本地和远程升级，让您售后无忧。产品提供了丰富开发接口。如您需要，支持应用程序的二次开发，方便根据业务所需定制应用。',

    moduleAdH0: '强大算力',
    moduleAdP00: '1、人工智能主控芯片，内置独立4TOPS NPU',
    moduleAdP01: '2、双核A55设计，主频高达2.0GHz, 峰值速度和低功耗兼顾',

    moduleAdH1: '开放算力',
    moduleAdP10: '1、支持主流网络训练模型实例，无需重新训练网络、模型训练工具即转即用',
    moduleAdP11: '2、支持Caffe、PyTorch、Tensorflow和Onnx模型的转换。提供8bit量化、16bit量化以及按层设定的混合量化支持',

    moduleAdH2: '内置算法',
    moduleAdP20: '1、人脸检测',
    moduleAdP21: '2、人体检测',

    moduleAdH3: '云边融合',
    moduleAdP30: '1、支持NeuLink协议接入Neucore公有云平台、及私有云平台部署，支持主流阿里云/AWS等平台',

    moduleAdH4: '丰富接口',
    moduleAdP40: '1、支持宽动态单路800万或500万输入，独立ISP及3A算法',
    moduleAdP41: '2、支持100M/1000M自适应网口',
    moduleAdP42: '3、支持MicroSD/Micro SDHC/Micro SDXC卡（64GB/128GB/256GB）本地存储',
    moduleAdP43: '4、1路DC12V电源输入，TDP≤2.5W',

    moduleAdH5: '多路多模态',
    moduleAdP50: '1、支持4路1080P网络摄像头和USB摄像头实时解码，人、车等多种目标实时检测及识别',

    BoardDetaulH1: 'NeuBoard智能分析盒',
    BoardDetaulH2: '视觉开发套件',

    boardAdP00: '1、支持主流网络训练模型实例，无需重新训练网络、模型训练工具即转即用',
    boardAdP01: '2、4核A73+2核A53大小核设计，主频高达2.2 GHz, 峰值速度和低功耗兼顾',

    boardAdP10: '1、人工智能主控芯片，内置独立5TOPS NPU',
    boardAdP11: '2、支持Caffe、PyTorch、Tensorflow和Onnx模型的转换。提供8bit量化、16bit量化以及按层设定的混合量化支持',

    boardAdP20: '1、人体结构化算法：人脸检测、人脸识别、性别年龄、帽子眼镜、人体检测、人体关节点、手势识别等',
    boardAdP21: '2、车辆结构化算法：车辆检测、车牌识别、车身颜色等',
    boardAdP22: '3、支持算法定制化开发',

    boardAdP40: '1、支持NeuLink协议接入Neucore公有云平台、及私有云平台部署，支持主流阿里云/AWS等平台',

    boardAdP50: '1、支持100M/1000M自适应网口',
    boardAdP51: '2、支持MicroSD/Micro SDHC/Micro SDXC卡（64GB/128GB/256GB）本地存储',
    boardAdP52: '3、2路USB2.0，1路MiniUSB接口',
    boardAdP53: '4、支持HDMI显示屏',
    boardAdP54: '5、1路DC12V电源输入，TDP≤5W',

    moduletableTH0: '项目',
    moduletableTH1: '组件',
    moduletableTH2: '规格',

    boardtableTd0: '硬件配置',
    boardtableTd1: 'AmlogicA311D，四核ARM Cortex A73 (2.2 GHz)+两核ARM Cortex A53 (1.8 GHz)',
    boardtableTd2: '独立AI神经处理单元，5 TOPS算力',
    boardtableTd3: '4KH.265、VP9和AVS2视频解码，支持1080pH.265/H.264视频编码',
    boardtableTd4: '4GB / 8GB / 16GB / 32GB eMMC5.1，支持标准256G Micro SD/SDHC/SDXC卡扩展存储',
    boardtableTd5: '接口',
    boardtableTd50: '100/1000M自适应RJ45×1，USB2.0×2，HDMI2.1×1',
    boardtableTd6: '电源状态LED灯×1,启动状态LED灯×1',
    boardtableTd7: 'DC±12V，配220V交流电源适配器，设备功率≤5W',
    boardtableTd8: '主要功能',
    boardtableTd9: '数据接入',
    boardtableTd10: '支持最多4路1080P接入实时解码，支持RTSP协议和H.264/H.265解码标准。',
    boardtableTd11: '支持人脸、人体、车牌、车辆4类检测对象，像素≥20×20可检测；每帧可检测目标数≥100，检测速度≤50ms，误检率≤1%，漏检率≤1%',
    boardtableTd12: '图片去重',
    boardtableTd13: '支持按图片质量/时间间隔去重，首张图片保留，重复率≤20%',
    boardtableTd14: '目标比对',
    boardtableTd15: '支持人脸、车牌实时比对。比对速度≤100ms（1:50000）。误报率≤1%，漏报率≤1%',
    boardtableTd16: '识别结果',
    boardtableTd17: '支持日期/时间、通道号、目标ID、抓拍图片、相似度、特征值等识别结果上传',
    boardtableTd18: '数据管理',
    boardtableTd19: '支持人脸库和车牌库数据的增删改查，支持库数据批量导入/导出；最大容量50000',
    boardtableTd20: '平台支持',
    boardtableTd21: '支持锘科云NeuLink协议；支持阿里云OSS',
    boardtableTd22: '机身',
    boardtableTd23: '尺寸',
    boardtableTd24: '主体136×136×40（mm），左右固定边相同100×15×2（mm）',
    boardtableTd25: '材质',
    boardtableTd26: '铝合金磨砂漆面',
    boardtableTd27: '颜色',
    boardtableTd28: '暗夜黑',
    boardtableTd29: '防护',
    boardtableTd30: 'IP31，可防止小固体侵入；水滴滴到外壳无影响',
    boardtableTd31: '安装',
    boardtableTd32: '可平放无固定，可平放/悬挂固定',
    boardtableTd33: '存储温度',
    boardtableTd34: '相对湿度',
    boardtableTd35: '≤95%RH，无凝结',
    boardtableTd36: '散热方式',
    boardtableTd37: '自然散热',
    boardtableTd38: '抗振性',
    boardtableTd39: '整体重量',
    boardtableTd40: '语言支持',
    boardtableTd41: '简体中文、英文',

    moduletableTd0: '项目',
    moduletableTd1: 'AmlogicC308X，双核ARM Cortex A55',
    moduletableTd2: '独立AI神经处理单元，4TOPS算力',
    moduletableTd3: '内存',
    moduletableTd4: '存储',
    moduletableTd5: '扩展存储',
    moduletableTd6: '支持标准256G Micro SD/SDHC/SDXC卡扩展存储',
    moduletableTd7: '视频输入',
    moduletableTd8: '支持800万的sensor (Sony 415 / Sony 334)和500万sensor (Sony 335)',
    moduletableTd9: '有线网络',
    moduletableTd10: '有线网支持POE供电，100/1000M 自适应',
    moduletableTd11: '无线网络',
    moduletableTd12: '802.11b/g/n，支持热点模式',
    moduletableTd13: '指示灯',
    moduletableTd14: '双色指示灯，指示电源和网络状态',
    moduletableTd15: '按钮',
    moduletableTd16: '1个Reset按钮，本地恢复出厂设置',
    moduletableTd17: '电源',
    moduletableTd18: 'DC±12V配220V交流电源适配器，设备功率≤2.5W',
    moduletableTd19: '标准接口',
    moduletableTd20: '音频输入输出，5x GPIO，3x UART，1x USB-OTG',
    moduletableTd21: '板框',
    moduletableTd22: '系统软件',
    moduletableTd23: '操作系统',
    moduletableTd24: 'NeuXOS，简体中文、英文',
    moduletableTd25: '视频编码',
    moduletableTd26: '4K @ 30FPS + 1080P @ 30FPS,H.265/H.264视频编码，JPEG编码',
    moduletableTd27: '多码流',
    moduletableTd28: '支持三码流（主码流，辅码流，第三码流）独立设置',
    moduletableTd29: '视频变换',
    moduletableTd30: '支持去雾模式，走廊模式，镜头矫正',
    moduletableTd31: '音频编码',
    moduletableTd32: 'G.711，G.726, ADPCM，AAC',
    moduletableTd33: 'OSD',
    moduletableTd34: '支持叠加时间，通道号，字体大小与颜色可设置',
    moduletableTd35: '日夜转换',
    moduletableTd36: '支持，IR-CUT自动切换',
    moduletableTd37: '语音对讲',
    moduletableTd38: '支持双向语音对讲，内置降噪和回声消除算法',
    moduletableTd39: '前端录像',
    moduletableTd40: '定时录像，移动侦测联动录像，5秒预录',
    moduletableTd41: '网络协议',
    moduletableTd42: '平台协议',
    moduletableTd43: '云对接',
    moduletableTd44: '支持NeuLink协议对接Neucore 云；支持阿里云；AmazonAWS',
    moduletableTd45: 'P2P视频',
    moduletableTd46: '支持P2P网络透传，支持iPhone和Android平台实时查看视频流',
    moduletableTd47: '智能功能',
    moduletableTd48: '支持遮挡检测、失焦检测、移动侦测、区域入侵、人形检测',
    moduletableTd49: '二次开发',
    moduletableTd50: '支持在摄像头上做二次开发，实现更多的业务应用',
    moduletableTd51: '适用环境',
    moduletableTd52: '工作温度',
    moduletableTd53: '可靠性',
    moduletableTd54: 'MTBF≥5000h，断电后来电自恢复',
    moduletableTd55: '人脸抓拍',
    moduletableTd56: '目标检测',
    moduletableTd57: '复杂环境下的人脸抓拍，每帧可检测目标数≥100，检测速度≤50ms，误检率≤1%，漏检率≤1%',
    moduletableTd58: '图片评分',
    moduletableTd59: '支持对运动人脸的筛选，评分',
    moduletableTd60: '去重选优',
    moduletableTd61: '支持按图片质量/时间间隔去重，首张图片保留，重复率≤20%',
    moduletableTd62: '上传结果',
    moduletableTd63: '支持日期/时间、通道号、目标ID，最优人脸，首张人脸，背景图',
    moduletableTd64: '人体抓拍',
    moduletableTd65: '目标检测',
    moduletableTd66: '支持头肩、全身的检测，最小检测目标35x10',
    moduletableTd67: '人数统计',
    moduletableTd68: '对人体进行跟踪和精准计数，人数统计误差精度在±10%以内',
    moduletableTd69: '人脸识别',
    moduletableTd70: '人脸底库',
    moduletableTd71: '支持最大5万人脸底库',
    moduletableTd72: '识别速度',
    moduletableTd73: '1秒内可识别30人',
    moduletableTd74: '识别精度',
    moduletableTd75: '误报率≤1%，漏报率≤1%',
    moduletableTd76: '人形属性',
    moduletableTd77: '性别',
    moduletableTd78: '性别准确率>95%',
    moduletableTd79: '年龄',
    moduletableTd80: '年龄误差<3.7岁',
    moduletableTd81: '口罩',
    moduletableTd82: '是否戴口罩，准确率>98.6%',
    moduletableTd83: '遮挡',
    moduletableTd84: '脸部是否遮挡，准确率>97.3%',
    moduletableTd85: '背包',
    moduletableTd86: '是否背包，准确率> 85%',
    moduletableTd87: '帽子',
    moduletableTd88: '是否戴帽子（例如：安全帽），准确率> 92.5%',
    moduletableTd89: '制服',
    moduletableTd90: '支持警察、快递、保洁等制服识别，准确率>93%',
    moduletableTd91: '车辆抓拍',
    moduletableTd92: '目标检测',
    moduletableTd93: '同时支持机动车、非机动车、行人三类目标检测，检出率> 95%',
    moduletableTd94: '无牌车辆',
    moduletableTd95: '可抓拍无牌车辆',
    moduletableTd96: '车牌识别',
    moduletableTd97: '识别精度',
    moduletableTd98: '车牌识别精度> 99.6%',
    moduletableTd99: '车牌类型',
    moduletableTd100: '支持绿牌车、蓝牌车、黄牌车和特殊车辆的车牌',
    moduletableTd101: '机动车属性',
    moduletableTd102: '车辆类型',
    moduletableTd103: '车牌识别精度> 99.6%',
    moduletableTd104: '车身颜色',
    moduletableTd105: '支持绿牌车、蓝牌车、黄牌车和特殊车辆的车牌',
    moduletableTd106: '车辆品牌',
    moduletableTd107: '识别出车辆品牌，准确率> 91.5%',

    sdktableTd0: '人脸分析',
    sdktableTd1: '人脸检测',
    sdktableTd2: '多人脸检测、验证活体（单目、双目）',
    sdktableTd3: '人脸识别',
    sdktableTd4: '人证比对、1：1、1：N、支持口罩模式',
    sdktableTd5: '人脸属性',
    sdktableTd6: '年龄、性别、是否戴口罩、是否戴帽子、是否戴眼镜、表情',
    sdktableTd7: '人脸关键点',
    sdktableTd8: '106个关键点，疲劳、打瞌睡、闭眼、专注度',
    sdktableTd9: '人体分析',
    sdktableTd10: '人体检测',
    sdktableTd11: '头肩检测、全身检测、数人头，Re-ID',
    sdktableTd12: '骨骼关键点',
    sdktableTd13: '全身18个骨骼关键点、卧倒、站立',
    sdktableTd14: '手势识别',
    sdktableTd15: '18种手势（1-10、Ok、No、Yes、比心、拳头、手掌）',
    sdktableTd16: '车辆分析',
    sdktableTd17: '车辆检测',
    sdktableTd18: '机动车、非机动车',
    sdktableTd19: '车牌识别',
    sdktableTd20: '车牌号码识别，普通牌照，绿牌',
    sdktableTd21: '车辆属性',
    sdktableTd22: '车身颜色、品牌、型号',
    sdktableTd23: '目标检测',
    sdktableTd24: '物体分割',
    sdktableTd25: '物体识别',
    sdktableTd26: '障碍物，裂纹，瑕疵检测',
    sdktableTd27: '文字识别',
    sdktableTd28: '标识，文字识别',
    sdktableTd29: '语音',
    sdktableTd30: '回声消除',
    sdktableTd31: '消除多次反射的声学回声，支持单麦和双麦',
    sdktableTd32: '噪音抑制',
    sdktableTd33: '消除背景噪音，例如风扇、空调声等噪音滤除，支持单麦和双麦',
    sdktableTd34: '关键词识别',
    sdktableTd35: '唤醒关键词本地识别',

    homenav2HPT: "边缘服务器",
    homenav2HPT0: "智能分析盒",
    homenav2HPT1: "视觉开发套件",

    ProductDetail: "产品详情",

    homenav2SPT: "算法开发包",
    homenav2SPT0: "NeuSDK Linux开发包",
    homenav2SPT1: "NeuSDK Android开发包",
    homenav2SPT2: "云端服务部署包",

    homenavCamera0: "智能摄像头",
    homenavCamera1: "网络高清摄像头",

    homenavSdk0: "NeuSDK 开发包",
    homenavSdk1: "NeuSDK Linux开发包",
    homenavSdk2: "NeuSDK Android开发包",

    SdkDescription: "Neucore基于独有的HCS框架，实现算法在CPU、NPU、GPU、DSP等多种架构的快速移植，实现端智能本地化高精度的人脸抓拍、人脸识别、人体捕捉、属性分析、行为识别等功能。本页面会更新最新的算法清单及Demo代码。",


    homenavCameraH0: "NeuCamera智能摄像头",
    homenavCameraH0_800: "NeuCamera智能摄像头_800万",
    homenavCameraH0_500: "NeuCamera智能摄像头_500万",
    homenavCameraH0_200: "NeuCamera智能摄像头_200万",
    homenavCameraH1: "NeuCamera网络高清摄像头",
    homenavCameraH1_800: "NeuCamera网络高清摄像头_800万",
    homenavCameraH1_500: "NeuCamera网络高清摄像头_500万",
    homenavCameraH1_200: "NeuCamera网络高清摄像头_200万",

    homenavModule: "摄像头模组",
    homenavModule0: "人脸抓拍模组",
    homenavModule1: "人脸比对模组",
    homenavModule2: "车牌识别模组",
    homenavModule3: "全结构化模组",
    homenavModule4: "网络高清模组",

    ModuleDetaulH1: "NeuCamera智能摄像头_人脸抓拍",
    ModuleDetaulH2: "NeuCamera智能摄像头_人脸比对",
    ModuleDetaulH3: "NeuCamera智能摄像头_车牌识别",
    ModuleDetaulH4: "NeuCamera智能摄像头_全结构化",
    ModuleDetaulH5: "网络高清模组",
    ModuleDetaulH1_800: "NeuCamera智能摄像头_人脸抓拍_800万",
    ModuleDetaulH1_500: "NeuCamera智能摄像头_人脸抓拍_500万",
    ModuleDetaulH1_200: "NeuCamera智能摄像头_人脸抓拍_200万",
    ModuleDetaulH2_800: "NeuCamera智能摄像头_人脸比对_800万",
    ModuleDetaulH2_500: "NeuCamera智能摄像头_人脸比对_500万",
    ModuleDetaulH2_200: "NeuCamera智能摄像头_人脸比对_200万",
    ModuleDetaulH3_800: "NeuCamera智能摄像头_车牌识别_800万",
    ModuleDetaulH3_500: "NeuCamera智能摄像头_车牌识别_500万",
    ModuleDetaulH3_200: "NeuCamera智能摄像头_车牌识别_200万",
    ModuleDetaulH4_800: "NeuCamera智能摄像头_全结构化_800万",
    ModuleDetaulH4_500: "NeuCamera智能摄像头_全结构化_500万",
    ModuleDetaulH4_200: "NeuCamera智能摄像头_全结构化_200万",
    ModuleDetaulH5_800: "网络高清模组_800万",
    ModuleDetaulH5_500: "网络高清模组_500万",
    ModuleDetaulH5_200: "网络高清模组_200万",

    CameraDetaulH1: "NeuCamera智能摄像头",
    CameraDetaulH1_800: "NeuCamera智能摄像头_800万",
    CameraDetaulH1_500: "NeuCamera智能摄像头_500万",
    CameraDetaulH1_200: "NeuCamera智能摄像头_200万",
    CameraDetaulH2: "NeuCamera网络高清摄像头",
    CameraDetaulH2_800: "NeuCamera网络高清摄像头_800万",
    CameraDetaulH2_500: "NeuCamera网络高清摄像头_500万",
    CameraDetaulH2_200: "NeuCamera网络高清摄像头_200万",

    homenavBoard0: "智能分析盒",
    homenavBoard1: "视觉开发套件",
    homenavBoardH0: "NeuBoard智能分析盒",
    homenavBoardH0_28: "NeuBoard智能分析盒2+8",
    homenavBoardH0_416: "NeuBoard智能分析盒4+16",
    homenavBoardH1: "视觉开发套件",
    homenavBoardH1_28: "视觉开发套件2+8",
    homenavBoardH1_416: "视觉开发套件4+16",
    boardDesctiption: "Neucore NeuBoard系列智能分析盒采用低功耗高性能人工智能芯片，以及Neucore先进的人工智能算法，在实现多路1080P视频流实时解码的同时，分别进行多种不同的目标检测和识别，为您的网络和服务器最大可能地减负，降低系统成本。5万大容量目标底库，HDMI图像实时显示，灵活的通道配置，超过99%的识别率，毫秒级的响应速度。产品配置工业级金属外壳，无风扇设计，自然高效散热，可在低至-30°C和高达+80°C的环境下稳定运行。接口丰富，适用性强，可快速应用于智能监控、人/车检测识别、名单布控等边缘计算场景",

    homenav2SNT: "摄像头整机",
    homenav2SNT0: "智能摄像头",
    homenav2SNT1: "网络高清摄像头",

    homenewTH0: "全栈的AI能力，提供端到端软硬一体的应用",
    homenewTHP0: "智能设备",
    homenewTHP1: "智能算法",
    homenewTHP2: "智能云端",

    homenewTH1: "源于实践的行业方案，赋能产业AI升级",
    homenewTH2: "丰富的开放平台，打造定制化的AI能力",
    homenewTH3: "合作伙伴计划，共建AI生态",

    homenewConstruction: "智慧工地",
    homenewTransportation: "智慧停车",
    homenewFactory: "智慧工厂",
    homenewEducation: "智慧教育",
    homenewBuilding: "智慧楼宇",
    homenewRetail: "新零售",
    homenewHos: "智慧医院",
    homenewBus: "公交车载",

    homenewTan0NPU: "AI开发套件",
    homenewTan0NPUDesc: "高TOPS及丰富的外围接口的AI开发板，支持Ubuntu，neuxos及Android操作系统，可进行二次开发。",
    homenewTan0interfaces: "摄像头模组",
    homenewTan0protion: "摄像头模组",
    homenewTan0interfacesDesc: "业内标准的38x38的摄像头模组，包括主控板，Sensor模组，及扩展板。模组自带neuxos系统及常用算法。",
    homenewTan0Os: "边缘服务器",
    homenewTan0productsDesc: "公模整机产品，整机已通过长时间的高低温测试，并可与市面上主流NVR及云平台对接，操作系统为neuxos。",
    homenewTan0products: "整机产品",
    homenewTan0OsDesc: "支持高达4路的1080P视频输入，从网络/UVC摄像头或视频文件，实时解码并分析视频内容。",

    changeNum0D: "技术能力",
    changeNum1D: "开放平台",
    changeNum2D: "小时",
    changeNum2De: "快速集成",

    homenewTan1det: "人脸识别",
    homenewTan1detD: "人脸检测（选优，去重），人脸识别，人脸特征值提取，检测人脸属性 – 性别、年龄、是否佩戴眼镜、口罩等。",
    homenewTan1any: "人体分析",
    homenewTan1anyD: "手势及人体姿态识别，手势支持自定义，人体姿态的关节点信息可被用于做复杂的分析，例如，坐姿是否正确。",
    homenewTan1car: "车辆结构化",
    homenewTan1carD: "车辆检测，并提取出车辆的结构化信息：机动车类型、车身颜色、车标、车牌号码识别。",
    homenewTan1so: "物体识别",
    homenewTan1soD: "通用物体检测和识别，例如检测障碍物，不明遗留物。",

    homenewTan2equ: "设备管理",
    homenewTan2equD: "通过MQTT实现的心跳包机制对设备进行状态管理，远程控制设备，远程调试，OTA升级，重启或关闭设备等。",
    homenewTan2bd: "大数据",
    homenewTan2bdD: "视觉数据的识别，提取，及大数据融合分析，数据集标定及在线生成多种数据用于算法训练。",
    homenewTan2trans: "P2P传输",
    homenewTan2transD: "业内领先的实时和低延迟的视频流和音频流传输，信令服务器确保超高连通率无论设备在任何网络条件下。",
    homenewTan2charts: "业务报表",
    homenewTan2chartD: "业务相关的管理后台，仪表盘，应用程序适配PC，H5，Android和IOS设备，并与第三方系统整合。",

    homeproductdesc: "全面的产品线充分利用计算能力，在边缘设备和云平台上实现最高性能。",
    homeproductseH0: "NeuEdge Module",
    homeproductseP0: "基于边缘计算SoC的视觉和语音模块，模块具有微调的视觉和语音 算法内置。",
    homeproductseH1: "NeuBoard Kit",
    homeproductseP1: "诺科板套件用作雾平台，支持多种视觉和语音流并分析实时内容。",
    homeproductseH2: "NeuOS SDK",
    homeproductseP2: "先进的SDK提供优化的A.I. 算法，各种接口和全功能协议应用开发者。",
    homeproductseH3: "NeuServer Cloud",
    homeproductseP3: "可以部署公共或私有服务器来管理所有设备，并作为SAAS平台来支持各种服务。",
    homesolution: "解决方案",
    homesolutiondesc: "为了帮助我们的合作伙伴缩短产品上市时间，我们根据对垂直行业市场的了解，对交钥匙解决方案进行了精心设计和优化。",
    homesolutionbtn: "更多细节",
    homesolutionp0: "新零售",
    homesolutionp1: "新产业",
    homesolutionp2: "ADAS",
    homesolutionp3: "智能家居",
    homesolutionp4: "新安保",
    homesolutionp5: "智能门禁",
    homecontact: "联系我们",
    homecontactdesc: "如果您在产品介绍，商业机会和商业机会方面有任何信息，请随时与我们联系 售前/售后支持。",
    homebtn: "点击咨询",
    footerTel: "电话",
    footerEmail: "邮箱",
    footerAddr: "地址",
    footerFax: "传真",
    footerAddrdesc: "中国上海市浦东新区秀浦路2555号漕河泾康桥商务绿洲E5栋",
    footerCopy: "Copyright © 2018 - 2020 Neucore. All Rights Reserved.",
    footerba: "沪ICP备18031700号-1",
    "Who is Neucore?": "关于我们",
    aboutUsP0: "上海锘科智能科技（Neucore）于2018年5月成立于上海张江高科，是一家专注于端侧智能操作系统、智能算法、智能设备研发的人工智能公司，深耕于嵌入式视觉和语音研发，通过AI芯片实现智能终端产品。",
    aboutUsP1: "Neucore基于独有的HCS框架，可实现算法在CPU、NPU、GPU、DSP等多种架构的快速移植，实现端智能本地化高精度的人脸抓拍、人脸识别、人体捕捉、属性分析、行为识别等功能。",
    aboutUsP2: "Neucore通过端智能的软硬一体产品，赋能合作伙伴快速构建灵活的AI场景应用，提供完整的智慧商业、智慧安防、智慧车载等多个行业解决方案。",
    "Neucore Intelligence is a very creative, dynamic and young Artificial Intelligence company focused on computer vision and deep learning. We were founded in May, 2018 and located in Shanghai city, China. With the mission of making the AI on device for everyone and in everywhere, we are committed to developing innovative Artificial Intelligent solution to meet the requirements of every customer. Our solutions can be used in smart security, smart retail, smart home, automobile, smart factory, and so forth.": "上海锘科智能科技（Neucore）于2018年5月成立于上海张江高科，是一家专注于端侧智能操作系统、智能算法、智能设备研发的人工智能公司，深耕于嵌入式视觉和语音研发，通过AI芯片实现智能终端产品。Neucore基于独有的HCS框架，可实现算法在CPU、NPU、GPU、DSP等多种架构的快速移植，实现端智能本地化高精度的人脸抓拍、人脸识别、人体捕捉、属性分析、行为识别等功能。Neucore通过端智能的软硬一体产品，赋能合作伙伴快速构建灵活的AI场景应用，提供完整的智慧商业、智慧安防、智慧车载等多个行业解决方案。",
    chinesextra: "Neucore是人工智能技术商业化的先行者，于2018年5月成立于上海张江高科，客户主要包括硬件制造商、方案商及系统集成商。",
    "Company Overview": "公司简介",
    "The entrepreneurial team is a master of a famous university or a core of a well-known foreign company. The management team members have 12 years + industry experience.": "创业团队均为名校硕士或知名外企核心，管理团队成员均具备12年+业内经验",
    "Start-up Team": "创业团队",
    "Number Of Workers": "员工人数",
    "Our current team has 33 core employees and plans to grow to more than 50 people this year": "我们当前团队核心员工为33人，计划今年增长到50人+",
    "We have full stack technology capabilities from chip design, device drivers, operating systems to application software.": "我们具备从芯片设计，设备驱动，操作系统到应用软件的全栈技术能力",
    "Technical Strength": "技术力量",
    "Registration Time": "注册时间",
    "Our company started planning in October 2017, and the business registration time is May 2018.": "我们公司于2017年10月开始筹划，工商注册时间为2018年5月",
    "The current registered capital of the company is RMB 2.5 million, and the angel round financing has been completed.": "当前公司注册资本为人民币250万元，已完成天使轮融资",
    "Registered Capital": "注册资本",
    "Company Type": "公司性质",
    "We are an artificial intelligence solution provider focused on fast landing.": "我们是一家专注在快速落地的人工智能解决方案商",
    "Meet Our Team": "认识我们的团队",
    "CEO, Cooper is responsible for Neucore’s vision and overall market strategy and execution.": "创始人兼首席执行官，负责Neucore的愿景和整体市场战略与执行。前ARM总监，负责ARM在中国区Image & Vision业务拓展。2005年硕士毕业于西安交通大学。",
    "VP, Robot is leading artificial intelligence research, collaboration and implementation.": "合伙人兼副总裁，领导人工智能算法团队在计算机视觉及语音处理算法研究及实现。前华为人工智能实验室首席算法专家。2005年硕士毕业于西南交通大学。",
    "VP, Wayne is in charge of the NeuOS system architecture and embedded software development.": "合伙人兼副总裁，领导嵌入式团队开发高度适用于端侧智能设备的neuxos系统及NeuSDK软件开发包。曾就职于ARM，Intel图形图像部门。2006年硕士毕业于上海交通大学。",

    OpenPlatT0: "硬件参考设计",

    OpenPlatD0: "芯片原厂硬件参考设计，包括原理设计图，及布局布线图",

    OpenPlatT1: "neuxos 操作系统",

    OpenPlatD1: "专为端侧AI平台设计的基于Linux的轻量级操作系统，含AI框架及协议层",

    OpenPlatT2: "NeuSDK 安卓开发包",

    OpenPlatD2: "Android SDK包括人脸检测，人脸属性，人脸识别，活体检测以及体温检测",

    OpenPlatT3: "云端部署包",

    OpenPlatD3: "云端服务私有化部署安装包，包括设备管理，AI能力，MQTT服务等",

    OpenPlatT4: "应用程序平台",

    OpenPlatD4: "手机端应用程序，H5网页应用程序，嵌入式设备端应用程序",

    OpenPlatT5: "网络模型转换",

    OpenPlatD5: "使用在线工具将训练好的网络模型转换成开发板上可以运行的格式",

    Product: "产品中心",
    "AI on device for you all": "让端侧智能设备无处不在",
    ProductTitle: "产品展示",
    Product0: "智能摄像头",
    Product1: "智能分析盒",
    Product0Int: "产品介绍",
    Product0secH0: "算法集成",
    Product0secP0: "内置人脸检测，去重，识别算法 车牌识别，车辆结构化",
    Product0secH1: "开放NeuOS",
    Product0secP1: "私有化算法易于接入 结构化数据上传，或本地存储 基本web界面和后台 支持常用的门禁控制协议",
    Product0secH2: "兼容协议",
    Product0secP2: "兼容协议 2 • 支持 Onvif, GB28281协议对接市面上主流NVR",
    Product0secH3: "云端融合",
    Product0secP3: "多设备管理后台 跨设备 A.I. 算法，特征值提取比对 本地支持5W底库 可定制的私有云方案",
    Product0secTdesc: "产品规格",
    Product0secT0: "分类",
    Product0secT1: "算法",
    Product0secT2: "场景",
    Product0secB0: "Main Chipset",
    Product0secB1: "SoC",
    Product0secB2: "Amlogic Soc, 2 Cores CPU，4TOPS NPU",
    Product0secB3: "RAM",
    Product0secB4: "1GB DDR4",
    Product0secB5: "ROM Storage",
    Product0secB6: "4GB EMMC",
    Product0secB7: "Codec",
    Product0secB8: "Coding standard",
    Product0secB9: "H.265 / H.264 / MJPEG",
    Product0secB10: "Coding rate",
    Product0secB11: "4K@30fps + 1080p@30fps",
    Product0secB12: "VBR and CBR",
    Product0secB13: "Support",
    Product0secB14: "Multi-channel",
    Product0secB15: "Support",
    Product0secB16: "Camera",
    Product0secB17: "Sensor",
    Product0secB18: "Sony IMX307 / IMX326 / IMX415 , OminiVision OS08A10",
    Product0secB19: "Day and night mode",
    Product0secB20: "IR-Cut filter",
    Product0secB21: "WDR",
    Product0secB22: "Yes",
    Product0secB23: "Denoise",
    Product0secB24: "2D/3D/Color noise reduction",
    Product0secB25: "ROI",
    Product0secB26: "Yes",
    Product0secB27: "Image",
    Product0secB28: "Image setting",
    Product0secB29: "Adjustable saturation, brightness, contrast, sharpness, rollover, time of exposure, etc",
    Product0secB30: "Interface",
    Product0secB31: "Protocol",
    Product0secB32: "Onvif / GB28281",
    Product0secB33: "Networking",
    Product0secB34: "TCP/IP, HTTP,FTP,DHCP,DNS,DDNS,RTP,RTSP, NTP,UPnP,SMTP",
    Product0secB35: "Network Interface",
    Product0secB36: "RJ45 / WIFI",
    Product0secB37: "Audio Output",
    Product0secB38: "Support",
    Product0secB39: "Audio input",
    Product0secB40: "Support",
    Product0secB41: "USB",
    Product0secB42: "USB 2.0",
    Product0secB43: "Storage",
    Product0secB44: "TF Card",
    Product0secB45: "GPIOAO(4x2.54mm fool proof connector/card)",
    Product0secB46: "Reset",
    Product0secB47: "1 key reset button",
    Product0secB48: "System light (LED)",
    Product0secB49: "1 GPIO(Green)",
    Product0secB50: "Power light (LED)",
    Product0secB51: "1 LED power light (Red)",
    Product0secB52: "Dimension",
    Product0secB53: "Size",
    Product0secB54: "150mm(L)*70mm(W)*60mm (H)",

    ProductHLT: "产品亮点",
    ProductHLH0: "系统输入",
    ProductHLP0: "支持100万/200万/500万/800万 宽动态传感器 双传感器输入 2D/3D/色域降",
    ProductHLH1: "系统配置",
    ProductHLP1: "灵活可配置的 FTP/OSS/MQTT/Redis图片/数据上传通道 支持断网内置存储图片及数据 支持NTP和手动对时设置 支持最小人脸设置 支持感兴趣区域 ROI 设置 支持静态或动态IP设置",
    ProductHLH2: "智能处理",
    ProductHLP2: "车牌检测，本地识别 人脸检测，去重，本地识别 人脸特征值上传 小图和背景图抓拍上传 支持门禁开关控制 支持最大50000人脸底库 远程批量注册人脸库 白名单/黑名单管理",

    Product1secH2: "Multi-channel video",
    Product1secP2: "4-channel1080P/8-channel 720P Support RTSP, MJPEG, UVC protocols Every single channel runs independently",
    Product1secB0: "Main Chipset",
    Product1secB1: "SoC",
    Product1secB2: "Amlogic Soc, 6 Cores CPU，5TOPS NPU",
    Product1secB3: "RAM",
    Product1secB4: "2GB DDR4",
    Product1secB5: "ROM Storage",
    Product1secB6: "8GB EMMC",
    Product1secB7: "Codec",
    Product1secB8: "Coding standard",
    Product1secB9: "H.265 / H.264 / MJPEG",
    Product1secB10: "Coding rate",
    Product1secB11: "1080p@60FPS",
    Product1secB12: "Decoding standard",
    Product1secB13: "H.265 / H.264 / VP9",
    Product1secB14: "Decoding rate",
    Product1secB15: "4Kx2K@60fps+1x1080P@60FPS",
    Product1secB16: "Camera",
    Product1secB17: "Sensor",
    Product1secB18: "Sony IMX307 / IMX326 / IMX415 , OminiVision OS08A10",
    Product1secB19: "Day and night mode",
    Product1secB20: "IR-Cut filter",
    Product1secB21: "WDR",
    Product1secB22: "Yes",
    Product1secB23: "Denoise",
    Product1secB24: "2D/3D/Color noise reduction",
    Product1secB25: "ROI",
    Product1secB26: "Yes",
    Product1secB27: "Image",
    Product1secB28: "Image setting",
    Product1secB29: "Adjustable saturation, brightness, contrast, sharpness, rollover, time of exposure, etc",
    Product1secB30: "Interface",
    Product1secB31: "Protocol",
    Product1secB32: "Onvif / GB28281",
    Product1secB33: "Networking",
    Product1secB34: "TCP/IP, HTTP,FTP,DHCP,DNS,DDNS,RTP,RTSP, NTP,UPnP,SMTP",
    Product1secB35: "Network Interface",
    Product1secB36: "RJ45 / WIFI / 4G",
    Product1secB37: "Audio Output",
    Product1secB38: "Support",
    Product1secB39: "Audio input",
    Product1secB40: "Support",
    Product1secB41: "USB",
    Product1secB42: "USB 3.0 type-A & Micro USB 2.0",
    Product1secB43: "Storage",
    Product1secB44: "TF Card",
    Product1secB45: "GPIOAO(4x2.54mm fool proof connector/card)",
    Product1secB46: "Reset",
    Product1secB47: "1 key reset button",
    Product1secB48: "System light (LED)",
    Product1secB49: "1 GPIO(Green)",
    Product1secB50: "Power light (LED)",
    Product1secB51: "1 LED power light (Red)",
    Product1secB52: "Dimension",
    Product1secB53: "Size",
    Product1secB54: "150mm(L)*70mm(W)*60mm (H)",
    Product1secB55: "Resolution and frame rate",
    Product1secB56: "50Hz: 25fps 1920×1080,1280×720",
    Product1secB57: "60Hz: 30fps 1920×1080,1280×720",
    Product1secB58: "UART",
    Product1secB59: "Display",
    Product1secB60: "HDMI",

    ProductAS: "产品应用",
    ProductAS0: "新零售",
    ProductAS1: "办公分析",
    ProductAS2: "楼宇门禁",
    ProductASP2: "近年来，随着不断发展 生物识别技术，门禁系统的迭代效应也在加速。 今天常见的生物识别门禁系统主要包括指纹访问 控制系统，虹膜门禁系统，面部识别门禁系统 系统和静脉识别访问控制。 它的进一步改进 安全，方便，舒适和管理控制。 由于其独特性 人体，生物识别密钥不能被复制，被盗或遗忘，所以它更多 受到公众的追捧。",
    ProductAS3: "智能家居",
    ProductASP3: "在监视所有者入睡后，电视是 自动关闭，灯光调整到睡眠模式和空气 净化器进入智能运行状态。",

    Solution: "解决方案",
    "AI Turnkey Solution of Device-to-Cloud": "可高度定制的基于深度学习的整体解决方案",
    SolutionTip: "方案优势",
    SolutionTH0: "AI芯片",
    SolutionTP0: "选择最适合应用场景的AI芯片和平台，含ISP，NPU，CPU等",
    SolutionTH1: "NeuOS开发平台",
    SolutionTP1: "自研的NeuOS开发平台为机器视觉和语音应用提供完善的二次开发。",
    SolutionTH2: "云端服务",
    SolutionTP2: "云端服务可提供公有或私有云部署，为设备提供OTA升级，设备管理，报表及大数据服务",
    SolutionTH3: "智能算法",
    SolutionTP3: "自研人脸/行为分析/机动车相关的算法模型，并通过全面的调试和验证，同时也可集成第三方算法。",
    SolutionTH4: "参考代码",
    SolutionTP4: "包括应用和插件在内的参考代码均提供在GPL版权下的开放源代码。",
    SolutionTH5: "智能生态",
    SolutionTP5: "整合智能应用开发，算法开发，中间件开发商，专业的ODM厂商等产业链伙伴，打造完整的端到云智能生态。",
    SolutionTH6: "低系统成本",
    SolutionTP6: "本地或云端无需AI服务器 端侧设备内置人工智能算法",
    SolutionTH7: "快速部署",
    SolutionTP7: "布线简单，即插即用 定焦镜头适应各种应用场景",
    SolutionCS: "云服务",
    SolutionCS0: "设备管理",
    SolutionCP0: "设备状态监控",
    SolutionCP1: "升级包管理",
    SolutionCP2: "日志分析",
    SolutionCP3: "设备远程控制",
    SolutionCS1: "人工智能",
    SolutionCP10: "跨设备人员跟踪",
    SolutionCP11: "亿级人脸识别",
    SolutionCP12: "在线语音/OCR",
    SolutionCP13: "网络训练及调优",
    SolutionCS2: "P2P视频",
    SolutionCP20: "信令服务",
    SolutionCP21: "P2P连接服务",
    SolutionCP22: "远程摄像头访问",
    SolutionCP23: "实时P2P视频流",
    SolutionCS3: "业务运营",
    SolutionCP30: "Web展示平台",
    SolutionCP31: "大数据分析",
    SolutionCP32: "报表生成",
    SolutionCP33: "H5和手机APP",

    solution0_H0: "新零售",
    solution0_P0: "客户画像,远程巡店,客流统计",
    solution0_Label0: "客户画像",
    solution0_Descript0: "Necuore以数据为驱动的新零售与消费品行业技术解决方案助您彻底改变经营方式以及客户体验，从而挖掘企业自身数据价值, 实现以消费者为中心的智慧零售。",
    solution0_DescriptH0: "实现零售门店敏捷运营",
    solution0_DescriptP0: "利用先进技术促进新零售与消费品门店发展，满足当今消费者水涨船高的数字期望。",
    solution0_DescriptH1: '借助 AI 转变零售客户体验',
    solution0_DescriptP1: '应用人工智能，为消费者提供量身定制的市场营销资讯及商品服务，打造智慧零售客户体验。',
    solution0_DescriptH2: '重塑零售和消费品供应链',
    solution0_DescriptP2: '通过动态零售供应链最大限度降低全球和本地事件对供应链的影响。',
    solution0_advantage: "方案优势",
    solution0_advantage0: "分层分级管理",
    solution0_advantage1: "24小时安全存储",
    solution0_advantage2: "支持与公安平台对接",
    solution0_advantage3: "实时告警推送",
    solution0_function: "功能案例",
    solution0_function0: "热力分布",
    solution0_function1: "人脸特征",
    solution0_function2: "职业特征",
    solution0_function3: "热点区域分析",
    solution0_function4: "员工在岗",
    solution0_function5: "远程巡店",
    solution0_Label1: "远程巡店",
    solution0_Descript1: "Necuore以数据为驱动的新零售与消费品行业技术解决方案助您彻底改变经营方式以及客户体验，从而挖掘企业自身数据价值, 实现以消费者为中心的智慧零售。",
    solution0_DescriptH00: "实现零售门店敏捷运营",
    solution0_DescriptP00: "利用先进技术促进新零售与消费品门店发展，满足当今消费者水涨船高的数字期望。",
    solution0_DescriptH01: "借助 AI 转变零售客户体验",
    solution0_DescriptP01: "应用人工智能，为消费者提供量身定制的市场营销资讯及商品服务，打造智慧零售客户体验。",
    solution0_DescriptH01: "重塑零售和消费品供应链",
    solution0_DescriptP01: "通过动态零售供应链最大限度降低全球和本地事件对供应链的影响。",
    solution0_advantage00: "方案优势",
    solution0_advantage01: "分层分级管理",
    solution0_advantage02: "24小时安全存储",
    solution0_advantage03: "支持与公安平台对接",
    solution0_advantage04: "实时告警推送",
    solution0_function00: "功能案例",
    solution0_function01: "远程看店",
    solution0_function02: "实时查岗",
    solution0_function03: "店内动态",
    solution0_function04: "热点区域分析",
    solution0_function05: "员工在岗",
    solution0_function06: "远程巡店",
    solution0_Label2: "客流统计",
    solution0_Descript2: "Necuore以数据为驱动的新零售与消费品行业技术解决方案助您彻底改变经营方式以及客户体验，从而挖掘企业自身数据价值, 实现以消费者为中心的智慧零售。",
    solution0_DescriptH000: "实现零售门店敏捷运营",
    solution0_DescriptP000: "利用先进技术促进新零售与消费品门店发展，满足当今消费者水涨船高的数字期望。",
    solution0_DescriptH001: "借助 AI 转变零售客户体验",
    solution0_DescriptP001: "应用人工智能，为消费者提供量身定制的市场营销资讯及商品服务，打造智慧零售客户体验。",
    solution0_DescriptH002: "重塑零售和消费品供应链",
    solution0_DescriptP002: "通过动态零售供应链最大限度降低全球和本地事件对供应链的影响。",
    solution0_advantage000: "方案优势",
    solution0_advantage001: "分层分级管理",
    solution0_advantage002: "24小时安全存储",
    solution0_advantage003: "支持与公安平台对接",
    solution0_advantage004: "实时告警推送",
    solution0_function000: "功能案例",
    solution0_function001: "VIP客户识别",
    solution0_function002: "驻店时长",
    solution0_function003: "客流统计",
    solution0_function004: "热点区域分析",
    solution0_function005: "员工在岗",
    solution0_function006: "远程巡店",

    solution1_H0: "智慧安防",
    solution1_P0: "人体分析,车辆分析,物体分析",
    solution1_Label0: "人体分析",
    solution1_Descript0: "Necuore以数据为驱动的新零售与消费品行业技术解决方案助您彻底改变经营方式以及客户体验，从而挖掘企业自身数据价值, 实现以消费者为中心的智慧零售。",
    solution1_DescriptH0: "实现零售门店敏捷运营",
    solution1_DescriptP0: "利用先进技术促进新零售与消费品门店发展，满足当今消费者水涨船高的数字期望。",
    solution1_DescriptH1: '借助 AI 转变零售客户体验',
    solution1_DescriptP1: '应用人工智能，为消费者提供量身定制的市场营销资讯及商品服务，打造智慧零售客户体验。',
    solution1_DescriptH2: '重塑零售和消费品供应链',
    solution1_DescriptP2: '通过动态零售供应链最大限度降低全球和本地事件对供应链的影响。',
    solution1_advantage: "方案优势",
    solution1_advantage0: "分层分级管理",
    solution1_advantage1: "24小时安全存储",
    solution1_advantage2: "支持与公安平台对接",
    solution1_advantage3: "实时告警推送",
    solution1_function: "功能案例",
    solution1_function0: "人流统计",
    solution1_function1: "运动矫正",
    solution1_function2: "摔倒检测",
    solution1_function3: "热点区域分析",
    solution1_function4: "员工在岗",
    solution1_function5: "远程巡店",
    solution1_Label1: "车辆分析",
    solution1_Descript1: "Necuore以数据为驱动的新零售与消费品行业技术解决方案助您彻底改变经营方式以及客户体验，从而挖掘企业自身数据价值, 实现以消费者为中心的智慧零售。",
    solution1_DescriptH00: "实现零售门店敏捷运营",
    solution1_DescriptP00: "利用先进技术促进新零售与消费品门店发展，满足当今消费者水涨船高的数字期望。",
    solution1_DescriptH01: "借助 AI 转变零售客户体验",
    solution1_DescriptP01: "应用人工智能，为消费者提供量身定制的市场营销资讯及商品服务，打造智慧零售客户体验。",
    solution1_DescriptH01: "重塑零售和消费品供应链",
    solution1_DescriptP01: "通过动态零售供应链最大限度降低全球和本地事件对供应链的影响。",
    solution1_advantage00: "方案优势",
    solution1_advantage01: "分层分级管理",
    solution1_advantage02: "24小时安全存储",
    solution1_advantage03: "支持与公安平台对接",
    solution1_advantage04: "实时告警推送",
    solution1_function00: "功能案例",
    solution1_function01: "车辆检测",
    solution1_function02: "车流统计",
    solution1_function03: "车型识别",
    solution1_function04: "热点区域分析",
    solution1_function05: "员工在岗",
    solution1_function06: "远程巡店",
    solution1_Label2: "物体分析",
    solution1_Descript2: "Necuore以数据为驱动的新零售与消费品行业技术解决方案助您彻底改变经营方式以及客户体验，从而挖掘企业自身数据价值, 实现以消费者为中心的智慧零售。",
    solution1_DescriptH000: "实现零售门店敏捷运营",
    solution1_DescriptP000: "利用先进技术促进新零售与消费品门店发展，满足当今消费者水涨船高的数字期望。",
    solution1_DescriptH001: "借助 AI 转变零售客户体验",
    solution1_DescriptP001: "应用人工智能，为消费者提供量身定制的市场营销资讯及商品服务，打造智慧零售客户体验。",
    solution1_DescriptH002: "重塑零售和消费品供应链",
    solution1_DescriptP002: "通过动态零售供应链最大限度降低全球和本地事件对供应链的影响。",
    solution1_advantage000: "方案优势",
    solution1_advantage001: "分层分级管理",
    solution1_advantage002: "24小时安全存储",
    solution1_advantage003: "支持与公安平台对接",
    solution1_advantage004: "实时告警推送",
    solution1_function000: "功能案例",
    solution1_function001: "背包检查",
    solution1_function002: "品质把控",
    solution1_function003: "自助结账",
    solution1_function004: "热点区域分析",
    solution1_function005: "员工在岗",
    solution1_function006: "远程巡店",


    solution2_H0: "智慧车载",
    solution2_P0: "司乘行为分析,高级辅助驾驶",
    solution2_Label0: "司乘行为分析",
    solution2_Descript0: "Necuore以数据为驱动的新零售与消费品行业技术解决方案助您彻底改变经营方式以及客户体验，从而挖掘企业自身数据价值, 实现以消费者为中心的智慧零售。",
    solution2_DescriptH0: "实现零售门店敏捷运营",
    solution2_DescriptP0: "利用先进技术促进新零售与消费品门店发展，满足当今消费者水涨船高的数字期望。",
    solution2_DescriptH1: '借助 AI 转变零售客户体验',
    solution2_DescriptP1: '应用人工智能，为消费者提供量身定制的市场营销资讯及商品服务，打造智慧零售客户体验。',
    solution2_DescriptH2: '重塑零售和消费品供应链',
    solution2_DescriptP2: '通过动态零售供应链最大限度降低全球和本地事件对供应链的影响。',
    solution2_advantage: "方案优势",
    solution2_advantage0: "分层分级管理",
    solution2_advantage1: "24小时安全存储",
    solution2_advantage2: "支持与公安平台对接",
    solution2_advantage3: "实时告警推送",
    solution2_function: "功能案例",
    solution2_function0: "疲劳驾驶",
    solution2_function1: "行程安全",
    solution2_function2: "纠纷取证",
    solution2_function3: "热点区域分析",
    solution2_function4: "员工在岗",
    solution2_function5: "远程巡店",
    solution2_Label1: "高级辅助驾驶",
    solution2_Descript1: "Necuore以数据为驱动的新零售与消费品行业技术解决方案助您彻底改变经营方式以及客户体验，从而挖掘企业自身数据价值, 实现以消费者为中心的智慧零售。",
    solution2_DescriptH00: "实现零售门店敏捷运营",
    solution2_DescriptP00: "利用先进技术促进新零售与消费品门店发展，满足当今消费者水涨船高的数字期望。",
    solution2_DescriptH01: "借助 AI 转变零售客户体验",
    solution2_DescriptP01: "应用人工智能，为消费者提供量身定制的市场营销资讯及商品服务，打造智慧零售客户体验。",
    solution2_DescriptH01: "重塑零售和消费品供应链",
    solution2_DescriptP01: "通过动态零售供应链最大限度降低全球和本地事件对供应链的影响。",
    solution2_advantage00: "方案优势",
    solution2_advantage01: "分层分级管理",
    solution2_advantage02: "24小时安全存储",
    solution2_advantage03: "支持与公安平台对接",
    solution2_advantage04: "实时告警推送",
    solution2_function00: "功能案例",
    solution2_function01: "车道偏离预警",
    solution2_function02: "盲点监测",
    solution2_function03: "自适应巡航",
    solution2_function04: "热点区域分析",
    solution2_function05: "员工在岗",
    solution2_function06: "远程巡店",



    "Join Us": "加入我们",
    "Do something that is changing humanity": "做一件改变人类的事情",
    JoinSecH0: "校园招聘",
    JoinSecH1: "社会招聘",
    JoinSecBtn: "查看职位",
    JoinTitle: "诺科一句",
    JoinP: "勇敢的诺科人带着坚定的信念，在拓展人工智能新疆界的路上披荆斩棘，这一路既艰险又十分有趣，迸发了无数的睿智言论",

    "Social recruitment": "社会招聘",
    "School recruitment": "校园招聘",
    "We hope to enhance the relationship between people and smart devices through our own products.": "我们希望通过自己的产品增强人与智能设备之间的关系",
    SocialH0: "计算机视觉算法工程师",
    SocialP0: "工作地点: 上海市",
    SocialSecH0: "职责描述",
    SocialSecP0: "1. 负责算法及其集成（目标检测与识别，人脸识别，行为识别等AI算法）",
    SocialSecP01: "2. 负责算法在具体应用场景中的落地",
    SocialSecP02: "3. 与团队协作，对算法调优，提供优质的交付",
    SocialSecH01: "任职要求",
    SocialSecP010: "1. 3年左右工作经验，有扎实的Linux嵌入式发开经验",
    SocialSecP011: "2. 有图像处理基础，了解opencv，openvx等",
    SocialSecP012: "3. 对AI算法训练框架有学习的兴趣，包括但不限于TensorFlow和caffe等",

    SocialH1: "计算机视觉算法工程师（算法应用与集成方向）",
    SocialP1: "工作地点: 上海市",
    SocialSecH10: "职责描述",
    SocialSecP10: "1. 负责计算机视觉算法在芯片平台上的移植、调试、优化和问题解决",
    SocialSecP11: "2. 负责图像处理、计算机视觉常用算法的研发工作",
    SocialSecP12: "3. 负责算法封装和发布工作以及系统联调工作",
    SocialSecH11: "任职要求",
    SocialSecP110: "1. 人工智能 或 信号处理（图像方向）或 模式识别 或 计算机技术 相关专业",
    SocialSecP111: "2. 熟练C/C++/Python编程",
    SocialSecP112: "3. 有嵌入式编程和调试经验优先",
    SocialSecP113: "4. 熟悉openCV编程优先",
    SocialSecP114: "5. 熟悉openVX编程优先",
    SocialSecP115: "6. 熟悉caffe/tensorflow/keras框架做CNN图像算法（识别，检测，分割，跟踪）优先",

    SocialH2: "嵌入式Linux平台项目开发",
    SocialP2: "工作地点: 上海市",
    SocialSecH20: "职责描述",
    SocialSecP20: "1. 负责嵌入式Linux平台项目开发工作",
    SocialSecP21: "2. 参与和服务平台接口对接和调试",
    SocialSecP22: "3. 参与客户端产品的技术实现讨论，框架设计",
    SocialSecH21: "任职要求",
    SocialSecP210: "1. 3年以上C/C++开发经验",
    SocialSecP211: "2. 熟练掌握Linux C/C++ 程序设计，能熟练使用STL模板库",
    SocialSecP212: "3. 熟悉多线程开发",
    SocialSecP213: "4. 熟悉http、socket网络程序开发",
    SocialSecP214: "5. 熟悉常用的数据结构和算法",
    SocialSecP215: "6. 熟悉sqlite数据库编程",
    SocialSecP216: "7. 有嵌入式Linux项目开发经验的优先",
    SocialSecP217: "8. 熟悉常用的设计模式",
    SocialSecP218: "9. 熟悉常见的异常处理和排查解决的方法",

    AboutMission: "企业愿景",

    AboutMissT: "让AI走进千家万户",

    AboutMiss1T: "成为中国领先的端侧智能供应商",

    AboutMiss2T: "客户第一 团队协作 积极创新 爱岗敬业",

    SocialSecEmail: "发送您的简历到 : hr@neucore.com",

    TopContact: "商务咨询",
    "Send Message": "发送消息"
};
export default zh;